import { useSearchParams } from "react-router-dom";

import css from "./styles.module.scss";

export const Menu = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <video
      src={
        searchParams.get("part") === "1"
          ? "/videos/menu-part-1.v2.mp4"
          : "/videos/menu-part-2.mp4"
      }
      autoPlay
      muted
      loop
      className={css.Menu}
    />
  );
};
